export enum IThemeModeEnum {
  ROYAL_LIGHT = "royal-light",
  BONDI_LIGHT = "bondi-light",
  ROYAL_DARK = "royal-dark",
  BONDI_DARK = "bondi-dark",
  GOLD_LIGHT = "gold-light",
  GOLD_DARK = "gold-dark",
}
